import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import { format, parseISO } from 'date-fns';

import { Container } from './styles';

interface MessageProps {
  content: string;
  isMe: boolean;
  date: string;
  status?: 'sent' | 'read';
  readAt?: string | null;
}

const ChatMessageBubble: React.FC<MessageProps> = ({
  content,
  isMe,
  date,
  status,
  readAt,
}) => {
  const readTitle = useMemo(() => {
    if (status !== 'read') return 'Enviada';
    try {
      return readAt
        ? `Lida em ${format(parseISO(readAt), 'dd/MM/yyyy HH:mm')}`
        : 'Lida';
    } catch (e) {
      return 'Lida';
    }
  }, [status, readAt]);

  const cleanText = useMemo(() => {
    let text = content;
    text = text
      .replace(/<analise_interna>[\s\S]*?<\/analise_interna>/g, '')
      .replace(/<memoria>[\s\S]*?<\/memoria>/g, '')
      .replace(/<eventdata>[\s\S]*?<\/eventdata>/g, '')
      .replace(/<userdata>[\s\S]*?<\/userdata>/g, '')
      .replace(/<agent>[\s\S]*?<\/agent>/g, '')
      .replace(/<ui-options>[\s\S]*?<\/ui-options>/g, '')
      .replace(/<Fim>[\s\S]*?<\/Fim>/g, '')
      .replace(/<FIM>[\s\S]*?<\/FIM>/g, '')
      .replace(/<fim>[\s\S]*?<\/fim>/g, '');

    return text.trim();
  }, [content]);

  if (!cleanText) return null;

  return (
    <Container
      className={`chat-ballon py-3 px-3 mb-4 ${isMe ? 'bg-me ms-auto' : 'bg'}`}
    >
      <div>
        <div className="markdown-body">
          <ReactMarkdown>{cleanText}</ReactMarkdown>
        </div>
      </div>
      <p className="message-date mb-0 text-end">
        {date}
        {status && (
          <span
            title={readTitle}
            style={{
              marginLeft: 6,
              fontWeight: 700,
              color: status === 'read' ? '#2196f3' : '#9e9e9e',
            }}
          >
            {status === 'read' ? '✓✓' : '✓'}
          </span>
        )}
      </p>
    </Container>
  );
};

export default ChatMessageBubble;
